import script from "./yuedu.vue?vue&type=script&setup=true&lang=js"
export * from "./yuedu.vue?vue&type=script&setup=true&lang=js"

import "./yuedu.vue?vue&type=style&index=0&id=7c753c8b&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c753c8b"]])

export default __exports__